export default [
  {
    label: "Home",
    path: "/",
    color: "#ff0055",
  },
  {
    label: "Contact",
    path: "/contact",
    color: "#0099ff",
  },
  {
    label: "Threeeee",
    path: "/threeeee",
    color: "#ffaa00",
  },
  {
    label: "About",
    path: "/about",
    color: "#22cc88",
  },
  // {
  //   label: "Home2",
  //   path: "/hometwo",
  //   color: "#ff0055",
  // },
  // {
  //   label: "Contact3",
  //   path: "/contact3",
  //   color: "#0099ff",
  // },
  // {
  //   label: "Threeeee2",
  //   path: "/threeeee2",
  //   color: "#ffaa00",
  // },
  // {
  //   label: "About2",
  //   path: "/about2",
  //   color: "#22cc88",
  // },
];
